import { MarkdownViewerController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Markdown viewer component
 * @example
 * ```html
 * <salaxy-markdown-viewer ng-model="row.md"></salaxy-markdown-viewer>
 * ```
 */
export class MarkdownViewer extends ComponentBase {

    /** ng-model containing markdown */
    public require = {
      model: "ngModel",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the MarkdownViewerController */
    public controller = MarkdownViewerController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/MarkdownViewer.html";
}
